var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board",class:{
    'is-dev': _vm.isDev,
  },style:({
    transform: ("scale(" + _vm.scale + ")"),
  })},[_c('div',{staticClass:"board__aside"},[_c('app-aside',{staticClass:"board__aside-component"})],1),_vm._v(" "),_c('div',{staticClass:"board__content"},[_c('slide-view',{staticClass:"board__content-component"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }